import React from 'react';

import { generateRouteUrl } from '../../../utils/core';
import { navigate } from '@reach/router';

/**
 * @param {string} navigateTo
 * @param {string} buttonText
 * @param {string} buttonSummary 
 * @param {string} iconClass A Bootstrap glyphicon class 
 */
const DropdownListButton = ({ navigateTo, buttonText, buttonSummary, iconClass, tenantId }) => {

    const openAdminTab = (type) => {
        const route = generateRouteUrl({
            tabType: type,
            tenantId,
        });
        navigate(route);
    };

    return (
        <li className="dropdown-list-item">
            <button className="dropdown-link" onClick={() => openAdminTab(navigateTo)}>
                <span className={`glyphicon ${iconClass}`} />
                <div className="dropdown-content">
                    <span>{buttonText}</span>
                    <p>{buttonSummary}</p>
                </div>
            </button>
        </li>
    );
};

export default DropdownListButton;
